import http from "@/common/http.service";
const ROOT_URL = "dashboard";
const PERFORMANCE_URL = "dashboard/open-click-graph";
const SENT_GRAPH = "dashboard/sent-graph";
const GET_COUNTS = "dashboard/getlistsavailable";
const GET_WELCOME_DASH_DATA = "get-welcome-dashboard";
const GET_LISTCOUNT = "dashboard/listcounts";
const GET_CONTACT_SUMMARY = "dashboard/contact-summary";

export default {
  fetchDashBoardItems(params, cb) {
    http.post(ROOT_URL, params).then(function (response) {
      var data = { items: response.data };
      cb(data);
    });
  },
  fetchPeformanceGraph(params, cb) {
    http.post(PERFORMANCE_URL, params).then(function (response) {
      var data = { items: response.data };
      cb(data);
    });
  },
  fetchSendCountGraph(params, cb) {
    http.post(SENT_GRAPH, params).then(function (response) {
      var data = { items: response.data };
      cb(data);
    });
  },

  getAllCounts(params, cb) {
    http.post(GET_COUNTS, params).then(function (response) {
      var data = { items: response.data };
      cb(data);
    });
  },
  getWelcomeDashboard(params, cb) {
    http.post(GET_WELCOME_DASH_DATA, params).then(function (response) {
      var data = { items: response.data };
      localStorage.setItem(
        "welcomeDashboardItems",
        JSON.stringify(response.data)
      );
      if (parseInt(response.data.addCampaign) === 2) {
        localStorage.setItem("is_campaign_add", 2);
      }
      cb(data);
    });
  },

  getListCounts(params, cb) {
    http.post(GET_LISTCOUNT, params).then(function (response) {
      cb(response.data);
    });
  },
  fetchDoaminWiseReport(params, cb) {
    http.post(GET_CONTACT_SUMMARY, params).then(function (response) {
      var data = response.data.data;
      cb(data);
    });
  },
};
